import { render, staticRenderFns } from "./BookingAudienceRelevanceColumn.vue?vue&type=template&id=292ea8d2&"
import script from "./BookingAudienceRelevanceColumn.vue?vue&type=script&lang=js&"
export * from "./BookingAudienceRelevanceColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports